import axios from "@/api/axiosInstance";
import { FetchMyProductsHistoryCsvParams } from "./types";

export const fetchMyProductsHistoryCsv = async (
  params: FetchMyProductsHistoryCsvParams = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/my/products-history/export",
    { responseType: "blob", params },
  );
  return response.data;
};
